import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';

import { OrganizationsService } from '../../organizations/organizations.service';
import { ZenCustomersService } from '../zen-customers.service';
import { AuthService } from 'client/app/services/auth.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';

@Component({
	selector: 'app-zenmaster-marketplace-form',
	templateUrl: './zenmaster-marketplace-form.component.html',
	styleUrls: ['./zenmaster-marketplace-form.component.scss']
})
export class ZenmasterMarketplaceFormComponent implements OnInit, OnDestroy {
	ac = AppConstants;

	// 'standard' edit stuff
	id: number;
	zenmaster: Models.ZenMasterCustomer;
	errors: string[] = [];
	theForm: UntypedFormGroup;
	loading = true;
	saving = false;

	marketPlaceProductSelections: any = [];
	marketPlaceAccountIdLabel: string = 'ID';

	private userSubscription: Subscription;

	organizations: any[] = [];
	// other stuff
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private uiAlertsService: UiAlertsService,
		private organizationsService: OrganizationsService,
		private authService: AuthService,
		private zenCustomersService: ZenCustomersService) {
		this.route.paramMap.subscribe(params => {
			this.id = +params.get('id');
			if (this.id && this.id !== 0) {
				this.zenmaster = this.zenCustomersService.getOne(this.id);
				if (!this.zenmaster || this.zenmaster == null || this.zenmaster.id === 0) {
					this.router.navigate([AppConstants.urls.notfound]);
				}
			} else {
				this.router.navigate([AppConstants.urls.notfound]);
			}
			this.loading = false;
		});
	}

	ngOnInit(): void {
		this.userSubscription = this.authService.user.subscribe(authUser => {
			this.initForm();
		});

	}

	ngOnDestroy() {
		if (this.userSubscription) this.userSubscription.unsubscribe();
	}

	initForm() {
		let marketplace: string = '';
		let accountIdentifier: string = '';
		let productIdentifiers: string[] = [];

		if (this.zenmaster.marketplace != null && this.zenmaster.marketplace.marketplace && this.zenmaster.marketplace.marketplace !== '') {
			marketplace = this.zenmaster.marketplace.marketplace;
			accountIdentifier = this.zenmaster.marketplace.accountIdentifier;
			productIdentifiers = this.zenmaster.marketplace.productIdentifiers;
		} // if

		this.theForm = new UntypedFormGroup({
			marketplace: new UntypedFormControl(marketplace),
			accountIdentifier: new UntypedFormControl(accountIdentifier),
			productIdentifiers: new UntypedFormControl(productIdentifiers),
		});

		if (this.zenmaster.marketplace != null)
			this.onMarketplaceChange(false);

	}

	async onSubmit() {
		this.saving = true;
		this.errors = [];

		const marketplace: string = this.theForm.value.marketplace;
		const accountIdentifier: string = this.theForm.value.accountIdentifier;
		const productIdentifiers: string[] = this.theForm.value.productIdentifiers;

		if (marketplace != null && marketplace !== '') {
			if (accountIdentifier == null || accountIdentifier === '') {
				this.errors.push('You must provide an customer/account identifier');
			} else if (productIdentifiers == null || productIdentifiers.length === 0) {
				this.errors.push('You must select one or more products');
			} else {
				const newMarketplaceSettings = new Models.MarketPlaceConfiguration(marketplace, accountIdentifier, productIdentifiers);
				// if (this.zenmaster.marketplace){
				// 	newMarketplaceSettings.firstReport = this.zenmaster.marketplace.firstReport;
				// 	newMarketplaceSettings.latestReport = this.zenmaster.marketplace.latestReport;
				// } // if
				this.zenmaster.marketplace = newMarketplaceSettings;
			} // if
		} else {
			this.zenmaster.marketplace = null;
		} // if

		if (this.errors.length > 0) {
			this.uiAlertsService.addMsgs(this.errors, 'danger', '', false, AppConstants.standardMessageAutoCloseTimeSecs);
			this.saving = false;
			return;
		} // if

		try {
			const retPkg = await this.zenCustomersService.marketplaceUpdate(this.zenmaster);
			if (retPkg) {
				this.router.navigate([AppConstants.urls.zencustomers, this.id]);
				this.saving = false;
			} else {
				this.saving = false;
				this.uiAlertsService.addMsg('Something went wrong,', 'danger', '', false, AppConstants.standardMessageAutoCloseTimeSecs);
			}
		} catch (e: any) {
			this.saving = false;
			this.uiAlertsService.addMsg(e.message, 'danger', '', false, AppConstants.standardMessageAutoCloseTimeSecs);
		}
	}

	onCancel() {
		this.router.navigate([AppConstants.urls.zencustomers, this.id]);
	}

	onMarketplaceChange(wipeSelections: boolean) {
		this.marketPlaceProductSelections = [];

		if (wipeSelections) {
			this.theForm.controls['accountIdentifier'].setValue(null);
			this.theForm.controls['productIdentifiers'].setValue([]);
		} // if

		const selectedMarketplace = this.theForm.value.marketplace;
		if (selectedMarketplace != null && selectedMarketplace !== '') {
			let productSelections: any[] = [];
			const idx1 = MiscTools.findIndexGeneric(AppConstants.marketPlaceSelections, 'value', selectedMarketplace);
			if (idx1 !== -1) {
				productSelections = AppConstants.marketPlaceSelections[idx1].selections;
				this.marketPlaceAccountIdLabel = AppConstants.marketPlaceSelections[idx1].accountLabel;
			} // if

			for (const awsMarketPlaceProduct of productSelections) {
				if (awsMarketPlaceProduct.object_type === 'zenmaster') {
					this.marketPlaceProductSelections.push({
						value: awsMarketPlaceProduct.productCode,
						label: awsMarketPlaceProduct.label + '(' + awsMarketPlaceProduct.productCode + ')'
					});
				} // if
			} // for

		} // if
	}


	get zcp_type() { return this.theForm.get('zcp_type'); }
	get zcp_org_id() { return this.theForm.get('zcp_org_id'); }
}
